module.exports = __webpack_public_path__ + "static/media/up-arrow.f5a57b2a.svg";